<template>
  <div class="contractAward">
    <el-card>
      <el-form ref="filter" :model="filter" inline size="small" label-width="100px">
        <el-form-item label="学员手机号" prop="phone">
          <el-input v-model="filter.phone" placeholder="学员手机号" clearable />
        </el-form-item>
        <el-form-item label-width="120px" label=" ">
          <el-button type="primary" size="small" @click="search">搜索</el-button>
          <el-button type="" size="small" @click="reset('filter')">重置</el-button>
        </el-form-item>
      </el-form>
      <el-row>
        <el-button type="primary" size="small" @click="handerCLick('add')">添加</el-button>
      </el-row>
    </el-card>
    <br>
    <el-table :data="tableData" border>
      <el-table-column align="center" label="主键id" prop="id" min-width="120px" :formatter="fliteRData" />
      <el-table-column align="center" label="昵称" prop="nickname" min-width="120px" :formatter="fliteRData" />
      <el-table-column align="center" label="学员手机号" prop="phone" min-width="120px">
        <template slot-scope="{ row, $index }">
          <el-button type="text" @click="handleViewPhone(row, $index)">{{ row.phone || '--' }}</el-button>
        </template>
      </el-table-column>
      <el-table-column align="center" label="状态" prop="dataState" min-width="120px" :formatter="fliteRData">
        <template v-slot="{ row }">
          <el-tag type="success" v-if="row.dataState == 1">正常</el-tag>
          <el-tag type="danger" v-else-if="row.dataState == 2">冻结</el-tag>
          <span v-else>--</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="学员姓名" prop="realname" min-width="120px" :formatter="fliteRData" />
      <el-table-column align="center" label="证件类型" min-width="120px">
        <template v-slot="{ row }">
          <span v-if="row.type == 1">身份证</span>
          <span v-else-if="row.type == 2">港澳台身份证</span>
          <span v-else-if="row.type == 3">港澳台通行证</span>
          <span v-else> -- </span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="证件号码" prop="cardNo" min-width="120px" :formatter="fliteRData" />
      <el-table-column align="center" label="工作单位" prop="workCompany" min-width="120px" :formatter="fliteRData" />
      <el-table-column align="center" label="职业" prop="occupation" min-width="120px" :formatter="fliteRData" />
      <el-table-column align="center" label="常驻地" prop="usualResidence" min-width="120px" :formatter="fliteRData" />
      <el-table-column align="center" label="账号名称" prop="accName" min-width="120px" :formatter="fliteRData" />
      <el-table-column align="center" label="创建时间" prop="insertDate" min-width="180px" :formatter="fliteRData" />
      <el-table-column align="center" label="操作" min-width="120px" fixed="right">
        <template v-slot="{ row }">
          <el-button type="text" @click="handerCLick('edite',row)">编辑</el-button>
          <el-dropdown class="more" trigger="click" @command="handleCommand">
            <a href="javascript:void(0)" class="el-dropdown-link">
              更多<i class="el-icon-arrow-down el-icon--right"></i>
            </a>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :command="beforeHandleCommand(row,'changePassword')">修改密码</el-dropdown-item>
              <el-dropdown-item :command="beforeHandleCommand(row,'changePhone')">更换手机号</el-dropdown-item>
              <el-dropdown-item :command="beforeHandleCommand(row,'weixinjiebang')">微信解绑</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>
    </el-table>
    <br>
    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-sizes="pageSizes" layout="total, sizes, prev, pager, next" :total="total" />
    <!-- 修改密码 -->
    <changePassword ref="changePassword" @update="reset('filter')" />
    <!-- 更改手机号 -->
    <changePhone ref="changePhone" @update="reset('filter')" />
    <!-- 添加编辑学员 -->
    <studentAdd ref="studentAdd" @update="reset('filter')" />
  </div>
</template>

<script>
import tableMoudel from "@/libs/mixins/table"
import changePassword from "@/components/changePassword"
import changePhone from "@/components/changePhone"
import studentAdd from "@/components/studentAdd"

import { getListPage, unbindWechat } from "@/api/product/base"
import { getAppUserInfo } from "@/api/common";

const sexData = [
  { id: 1, name: "男" },
  { id: 2, name: "女" },
]

export default {
  mixins: [tableMoudel],
  components: { changePassword, changePhone, studentAdd },
  data () {
    return {
      sexData,
      filter: {
        phone: null
      }
    }
  },
  filters: {
    sexDataFilter (value) {
      const val = sexData.find(item => item.id == value)
      return val ? val.name : "--"
    }
  },
  created () {
    this.getData()
  },
  methods: {
    async getData () {
      console.log('获取数据')
      const params = {
        ...this.pageInfo,
        ...this.filter
      }
      const res = await getListPage(params)
      const { records, total } = res.data
      this.total = Number(total)
      this.tableData = records
    },
    beforeHandleCommand (row, command) {
      return {
        'row': row,
        'command': command
      }
    },
    async showDialog (name, item) {
      if (item && item.id) {
        const { data: { phone } } = await getAppUserInfo({ userId: item.id })
        item.phone = phone
      }
      this.$refs[name].init(item)
    },
    handerCLick (event, item) {
      switch (event) {
        case 'add':
          this.showDialog('studentAdd', null)
          break;
        case 'edite':
          this.showDialog('studentAdd', item)
          break;
        default:
          break;
      }
    },
    handleCommand (command) {
      const item = command.row
      switch (command.command) {
        case 'changePassword':
          console.log('修改密码')
          this.showDialog('changePassword', item)
          break;
        case 'changePhone':
          console.log('更改手机')
          this.showDialog('changePhone', item)
          break;
        case 'weixinjiebang':
          console.log('微信解绑')
          this.$confirm(`确定要解绑微信吗?`, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(async () => {
            const res = await unbindWechat({ id: item.id })
            if (res.code !== 0) {
              this.$message.error(res.message)
              return
            }
            this.$message.success('操作成功！')
            this.reset('filter')
          })
          break;
        default:
          break;
      }
    },
    handleViewPhone (row, index) {
      if (!/\*/.test(row.phone)) {
        return
      }
      getAppUserInfo({ userId: row.id }).then(({ code, data: { phone } }) => {
        if (code === 0) {
          this.tableData.forEach((item, i) => {
            if (i === index) {
              item.phone = phone
            }
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.more {
  margin-left: 10px;
}
.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
}
.el-icon-arrow-down {
  font-size: 12px;
}
</style>
